import { createContext } from 'react';
import {ID, Response} from '../../../../../_dashboard/helpers'

export interface FacilityTranslation {
  _id?:ID,
  facility_id?: ID;
  language: string;
  title: string;
}
export interface Icon {
  _id?: ID;
  url:string;
  seoUrl?:string;
 
}
export interface Facility {
  _id?: ID;
  translations: FacilityTranslation[];
  icon?:Icon;
 

}




export const initialFacility: Facility = {

  translations: [
    {
      language: 'en',
      title: '',
    },
  ],

};
export type FacilitysQueryResponse = Response<Array<Facility>>;
export type QueryResponseFacilityContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  refetchData: () => void
  isLoading: boolean
  query: any
}
export function createFacilityResponseContext<T>(initialState: QueryResponseFacilityContextProps<T>) {
  return createContext(initialState)
}
export const initialFacilityQueryResponse = { refetchData: () => { }, isLoading: false, query: '' }